<template>
    <div class="award-container">
        <div class="award-title">
            <img
                src="../img/award-title.png"
                alt="png">
        </div>
        <div class="award-common-content">
            <div
                v-if="award_lists.length>3"
                class="swiper-box">
                <div class="swiper">
                    <div
                        v-for="(item,index) in award_lists"
                        :key="index"
                        :class="index===stop_num?'award-item-select':''"
                        class="swiper-slide">
                        <div
                            class="award-item">
                            <div class="award-box">
                                <img
                                    :src="item.award_icon"
                                    alt="png">
                                <div class="cover-box">{{ item.award_title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-else-if="award_lists.length===3"
                class="three-award-box">
                <div
                    v-for="(item,index) in award_lists"
                    :key="index"
                    :class="index===stop_num?'award-item-select':''"
                    class="award-item">
                    <div class="award-box">
                        <img
                            :src="item.award_icon"
                            alt="png">
                        <div class="cover-box">{{ item.award_title }}</div>
                    </div>
                </div>
            </div>
            <div
                v-else
                class="two-award-box">
                <div
                    v-for="(item,index) in award_lists"
                    :key="index"
                    :class="index===stop_num?'award-item-select':''"
                    class="award-item">
                    <div class="award-box">
                        <img
                            :src="item.award_icon"
                            alt="png">
                        <div class="cover-box">{{ item.award_title }}</div>
                    </div>
                </div>
            </div>
            <div class="bottom-box">
                <div class="button-box">
                    <div
                        class="rule-box"
                        @click="showAwardRule(true)">
                        <img
                            src="../img/award-rule.png"
                            alt="png">
                    </div>
                    <div
                        class="luck-draw-box"
                        @click="beginAward">
                        <div>立即抽奖</div>
                        <div
                            v-if="is_login"
                            class="last-times">还剩{{ leftTimes }}次</div>
                        <div
                            v-else
                            class="last-times">登录</div>
                    </div>
                    <div
                        class="record-box"
                        @click="getRecordList(true)">
                        <img
                            src="../img/award-record.png"
                            png="png">
                    </div>
                </div>
                <div class="bottom-title">仅限本页开通可参与抽奖</div>
            </div>
        </div>
    </div>  
</template>
<script>
// comp
import AwardInfo from "./AwardInfo";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

// api
import { luckdraw } from "../api/lottery.api.js";

// const { log } = console;
export default {
    name: "Award",
    components: {
        AwardInfo, swiper, swiperSlide
    },
    props: {
        award_lists: {
            type: Array,
            default: function(){
                return [];
            }
        },
        is_login: {
            type: Boolean,
            default: false
        },
        lottery_balance: {
            type: [Number, String],
            default: 0,
        },
        activity_name: {
            type: String,
            default: ""
        },
        user_record_list: {
            type: Array,
            default: function(){
                return [];
            }
        }
    },
    data() {
        return {
            canAward: true,

            leftTimes: 0, // 剩余次数

            stop_num: -1,
            stopAward: {},  // 抽奖所中的奖品信息

            record_list: [], // 记录列表

            swiperOption: {
                slidesPerView: "auto",
            },

            timer: "",

        };
    }, 
    
    watch: {
        lottery_balance() {
            this.leftTimes = this.lottery_balance;
        }
    },

    created: function() {
        this.leftTimes = this.lottery_balance;
        this.getRecordList();
    },
    methods: {
        // 获取记录列表
        getRecordList(status=false){
            if(!this.is_login){
                if(status){
                    this.$emit("toLogin", "must");
                }
                return ;
            }
            this.record_list = this.user_record_list;
            this.is_record = status;
            if(status){
                this.$emit("openAwardDialog", status, this.record_list, this.stopAward);
            }
        },
        scrollToWhere(location) {
            if(location <= 0) return;
            const drag = 100;
            let swiper = document.querySelector(".swiper");
            let gap = swiper.scrollLeft;
            let that = this;
            if (location < gap) {
                let distance = (gap - location) / drag;
                this.timer = setInterval(()=> {
                    if (gap > location) {
                        if(swiper&&swiper.scrollTo&&gap) {
                            swiper.scrollTo(gap, 0);
                            gap = gap - distance;
                        }
                    } else {
                        clearInterval(that.timer);
                    }
                }, 10);
            } else {
                let distance = (location - gap) / drag;
                this.timer = setInterval(()=> {
                    if (gap < location) {
                        if(swiper&&swiper.scrollTo&&gap) {
                            swiper.scrollTo(gap, 0);
                            gap = gap + distance;
                        }
                    } else {
                        clearInterval(that.timer);
                    }
                }, 2);
            }
        },

        // 点击开始抽奖
        beginAward() {
            if(!this.is_login){
                this.$emit("toLogin", "must");
                return ;
            }
            if(!this.canAward) return;
            this.$emit("doTrack", "PayActivityBtnClk",  {
                ButtonName: "开始抽奖",
                H5Page: location.href
            });
            if(!this.leftTimes) {
                // this.showToast("次数不足");
                this.$emit("openVipHandler");
            } else {
                this.canAward = false;
                luckdraw({ 
                    activity_name: this.activity_name,
                    xdevice: window.__gvalkkmh.sys.device_id
                }).then(res => {
                    let { code, data, message } = res.data;
                    if (code !== 200)   {
                        this.canAward = true;
                        return this.showToast(message);
                    }
                    this.leftTimes = data.left_lottery_balance;
                    this.stopAward = {
                        award_name: data.award_name,
                        award_type: data.award_type,
                        award_title: data.award_title,
                        award_icon: data.award_icon,
                        award_desc: data.award_desc,
                        message_award_expire: data.words_info.message_award_expire || "",
                        award_url: ((data.target_info || {}).award_target || {}).target_web_url || "",
                    };
                    this.award_lists.map((item, index) => {
                        if(item.award_name == data.award_name) {
                            this.stop_num = index;
                            this.stopAward.award_url = ((item.target_info || {}).award_target || {}).target_web_url || "" ;
                            let that = this;
                            setTimeout(()=> {
                                let selectItem = document.querySelector(".award-item-select");
                                that.scrollToWhere(selectItem.offsetLeft - 120);
                            }, 100);
                        }
                    });
                    let that = this;
                    setTimeout(function() {
                        that.$emit("getUserRecordList");
                        that.targetAwardMask();
                    },1000);
                }).catch(err => {
                    this.showToast(err.message || err || "未知错误");
                });
            }
        }, 
        // 获奖弹窗
        targetAwardMask(){
            this.canAward = true;
            this.$emit("openAwardDialog", false, [], this.stopAward);
        },
        // swiper开始滚动
        startSwiper(){
            this.stop_num = -1;
            if(this.award_lists.length>3) {
                // var mySwiper = this.$refs.mySwiper.swiper;
                // mySwiper.autoplay.start();
            }
        },
        // toast展示
        showToast(text = "") {
            this.$emit("showToast", text);
        },
        // 展示活动规则
        showAwardRule() {
            this.$emit("showAwardRule");
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/vws.scss';
.award-title{
    width: vws(586px);
    height: vws(42px);
    margin: 0 auto;
    img {
        width: 100%;
        height: 100%;
        display: block;
    }
}

.award-common-content{
    width: vws(700px);
    height: vws(410px);
    background: #FEF6E4;
    border-radius: vws(20px);
    overflow: hidden;
    margin: vws(15px) auto vws(65px);
    .swiper-box{
        width: vws(648px);
        height: vws(198px);
        background: #F5DEBF;
        border: vws(4px) solid #FFEBBE;
        border-radius: vws(14px);
        margin: vws(20px) auto;
        padding: vws(20px) vws(10px) vws(20px) vws(10px);
        box-sizing: border-box;
        overflow: hidden;
    }
    .bottom-box .button-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .rule-box, .record-box{
            width: vws(46px);
            height: vws(82px);
            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }
        .luck-draw-box{
            width: vws(500px);
            height: vws(86px);
            text-align: center;
            background: #442509;
            border-radius: vws(43px);
            font-size: vws(32px);
            font-weight: 600;
            color: #FFFFFF;
            line-height: 1.2;
            display: flex;
            justify-content: center;
            align-content: center;
            flex-wrap: wrap;
            .last-times{
                font-size: vws(20px);
                font-weight: 400;
                width: 100%;
            }
        }
    }
    .bottom-title{
        text-align: center;
        font-size: vws(22px);
        color: #999999;
        padding: vws(20px) 0;
    }
    .swiper {
        width: 100%;
        display: flex;
        overflow-x: scroll;
        &::-webkit-scrollbar {
            z-index: -1111;
            display: none;
            width: 0;
            height: 0;
        }
        .swiper-slide {
            width: auto;
            display: flex;
            align-items: center;
        }
    }
    .three-award-box{
        width: vws(648px);
        height: vws(198px);
        background: #F5DEBF;
        border: vws(4px) solid #FFEBBE;
        border-radius: vws(14px);
        margin: vws(20px) auto;
        display: flex;
        align-items: center;
        .award-item {
            margin-left: vws(14px);
            padding: 0 vws(4px);
        }
    }
    .two-award-box {
        width: vws(648px);
        height: vws(198px);
        background: #F5DEBF;
        border: vws(4px) solid #FFEBBE;
        border-radius: vws(14px);
        margin: vws(20px) auto;
        display: flex;
        align-items: center;
        .award-item {
            margin-left: vws(84px);
        }
    }
    .award-item {
        padding: 0 vws(5px);
        .award-box{
            width: vws(188px);
            height: vws(158px);
            background: #FFFFFF;
            border-radius: vws(8px);
            position: relative;
            overflow: hidden;
            .cover-box{
                position: absolute;
                width: vws(168px);
                text-align: center;
                left: vws(10px);
                bottom: vws(15px);
                font-weight: 500;
                font-size: vws(24px);
                color: #4E494A;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
    .award-item-select {
        .award-box{
            width: vws(180px);
            height: vws(150px);
            background: #FFF8B5;
            border: vws(4px) solid #FFAC49;
            .cover-box{ 
                width: vws(160px);
                left: vws(10px);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/native/pay/vip/link_vip_multiple/comp/AwardCommon.vue